import React, { useState } from 'react'

import { Modal, Backdrop, Card, Box, makeStyles } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'

import useSalesConsents from './useSalesConsents'

const useStyles = makeStyles(() => ({
  modal: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
  card: {
    width: '936px',
    height: '80%',
    backgroundColor: '#fafafa',
  },
  iframe: {
    border: 'none',
  },
  icon: {
    cursor: 'pointer',
  },
}))

export default function SalesConsents() {
  const { modal, card, iframe, icon } = useStyles()

  const [modalOpen, setModalOpen] = useState(true)

  const { showConsents, consentsIframeSrc } = useSalesConsents()

  function onClose() {
    setModalOpen(false)
  }

  return showConsents ? (
    <>
      {window.addEventListener('message', (event) => {
        if (event.data === 'consents-success' || event.data === 'consents-error') {
          setTimeout(() => setModalOpen(false), 1000)
        }
      })}
      <Modal
        open={modalOpen}
        BackdropComponent={Backdrop}
        className={modal}
        disableAutoFocus
        disableEnforceFocus
      >
        <Box
          component={Card}
          borderRadius="14px"
          className={card}
          p={8}
          display="flex"
          flexDirection="column"
        >
          <Box textAlign="right">
            <CloseIcon data-hook="close-legal" onClick={onClose} className={icon} />
          </Box>
          <iframe
            id="salesConsentsIframe"
            className={iframe}
            title="Sales Consents"
            width="100%"
            height="100%"
            src={consentsIframeSrc}
          />
        </Box>
      </Modal>
    </>
  ) : (
    <></>
  )
}
